
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/heritageprizedraw/thank-you",
      function () {
        return require("private-next-pages/en/heritageprizedraw/thank-you.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/heritageprizedraw/thank-you"])
      });
    }
  